export default __webpack_public_path__ + "static/PictureLanding-0d84448fc2a5fd40b6011467e07abebc.jpg";